import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from './Toast';
import { AnimatePresence } from 'framer-motion';

const ToastContext = createContext();
let toastId = 0;

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback(({ title, message, type = 'info', animation = 'slide', duration = 5000 }) => {
    const id = toastId++;
    setToasts((prev) => [...prev, { id, title, message, type, animation, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);
  //

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column-reverse',
        alignItems: 'flex-end',
        pointerEvents: 'none'
      }}>
        <AnimatePresence initial={false}>
          {toasts.map((toast) => (
            <Toast key={toast.id} {...toast} onClose={removeToast} />
          ))}
        </AnimatePresence>
      </div>
    </ToastContext.Provider>
  );
};
